import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService<T> {
  _attachments: T[];

  set attachments(attachments: T[]) {
    this._attachments = attachments;
  }

  get attachments(): T[] {
    return this._attachments;
  }
}
